// extracted by mini-css-extract-plugin
export default {"barContainer":"SingleBar_barContainer__3yqD+","mainBar":"SingleBar_mainBar__pnIkb","border":"SingleBar_border__w6ENV","rate":"SingleBar_rate__-Tvx8"};